<template>
  <div
    :class="['c-nav-column', 'l-flex', 'l-flex--column', 'l-flex--align-start']"
  >
    <h2 class="t-heading-6 u-margin-bottom-small">
      {{ heading }}
    </h2>
    <template v-for="item in renderableNavItems">
      <component
        :is="item.contentType"
        :id="item.handle"
        :key="item.id"
        v-bind="item.data"
      />
    </template>
  </div>
</template>

<script>
import NavCard from "./sharedComponents/NavCard.vue";
import SwatchLink from "../swatch/SwatchLink.vue";
import LinkCard from "../card/LinkCard.vue";
import ImageCardCta from "../card/ImageCardCta.vue";
export default {
  components: { NavCard, SwatchLink, LinkCard, ImageCardCta },
  props: {
    heading: {
      type: String,
      default: "",
    },
    navItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    renderableNavItems() {
      const navItems = this.navItems
      let result = []
      for (let navItem of navItems) {
        if (navItem.contentType) {
          result.push(navItem)
        }
      }
      return result
    }
  }
};
</script>

<style lang="scss" scoped>
.c-nav-column {
  justify-content: flex-start;
  @include respond('tab-land') {
    .c-link-card::v-deep {
      width: auto;
    }
  }
  @include respond-min('desktop') {
    height: 100%;
    padding-bottom: 1rem;
    /*max-width: 140px;*/
    .c-link-card--image::v-deep {
      margin-top: auto;
      padding-bottom: 1rem;
      width: 200%;
      max-width: 100%;
    }
  }
  h2 {
    font-weight: 600;
    line-height: 22px;
  }
}
</style>
